import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { duyetMienGiamApi } from "../../../api/mien-giam/duyetMienGiamApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";

import { IDanhSachMienGiamSelectByLopsRequest } from "../../../model/request/mien-giam/IDanhSachMienGiamSelectByLopsRequest";
import {
  eDanhSachMienGiamActionIds,
  IDanhSachMienGiamActionTypes,
} from "../../action-types/mien-giam/IDanhSachMienGiamActions";
import { IProcessRequest } from "../../../model/request/IProcessRequest";

export function* danhSachMienGiamSaga(): any {
  yield takeLatest(eDanhSachMienGiamActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDanhSachMienGiamActionIds.DUYET_START, duyetWorker);
  yield takeEvery(eDanhSachMienGiamActionIds.HUY_DUYET_START, huyDuyetWorker);
}

function* loadWorker(action: IDanhSachMienGiamActionTypes): any {
  const res: IBaseRespone = yield call(
    duyetMienGiamApi.SelectAllByLop,
    action.payload as IDanhSachMienGiamSelectByLopsRequest
  );
  if (res.is_success) {
    yield put(rootActions.mienGiam.danhSachMienGiam.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mienGiam.danhSachMienGiam.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* duyetWorker(action: IDanhSachMienGiamActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IProcessRequest<number[]>;
  res = yield call(duyetMienGiamApi.DuyetAsync, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.mienGiam.danhSachMienGiam.DUYET_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.mienGiam.danhSachMienGiam.DUYET_ERROR(
          res.message ?? "Có lỗi"
        )
      );
    }
  }
}
function* huyDuyetWorker(action: IDanhSachMienGiamActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IProcessRequest<number[]>;
  res = yield call(duyetMienGiamApi.HuyDuyetAsync, payload);
  if (res) {
    if (res.is_success) {
      yield put(
        rootActions.mienGiam.danhSachMienGiam.HUY_DUYET_SUCCESS(res.data)
      );
    } else {
      yield put(
        rootActions.mienGiam.danhSachMienGiam.HUY_DUYET_ERROR(
          res.message ?? "Có lỗi"
        )
      );
    }
  }
}
